export class FraudDocumentModel {
    public id: number;
    public incidentNumberId: number;
    public documentTypeId: number;
    public documentNumber: string;
    public documentIssueDate: any;
    public deleted: boolean;
    public viewId: number;
    public showDeleteFraudDocumentButton = false;
}
